import { render, staticRenderFns } from "./choseCourseSchoolBaseGroup.vue?vue&type=template&id=4154e01f&scoped=true&"
import script from "./choseCourseSchoolBaseGroup.vue?vue&type=script&lang=js&"
export * from "./choseCourseSchoolBaseGroup.vue?vue&type=script&lang=js&"
import style0 from "./choseCourseSchoolBaseGroup.vue?vue&type=style&index=0&id=4154e01f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4154e01f",
  null
  
)

export default component.exports